import React from "react";
import "../../../../../css/Finance/Charges/ChargesCatalogTabs.css";

const ChargesCatalogTabs = ({ catalogs = [], selectedCatalogId, onSelect }) => {
  return (
    <div className="charges-catalog-tabs-wrap">
      {catalogs.map((catalog) => (
        <button
          key={catalog.id}
          type="button"
          className={
            "charges-catalog-tab-btn" +
            (catalog.id === selectedCatalogId ? " active" : "")
          }
          onClick={() => onSelect?.(catalog.id)}
        >
          {catalog.name}
        </button>
      ))}
    </div>
  );
};

export default ChargesCatalogTabs;
